/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaLineupPositionPlayerCreate = {
    properties: {
        playerId: {
            type: 'number',
            isRequired: true,
        },
        positionId: {
            type: 'number',
            isRequired: true,
        },
        booster: {
            type: 'any-of',
            contains: [{
                type: 'FantaBoosterType',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
